export default "__VITE_ASSET__DPzaR$Yy__"